import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { LogLevel } from '../interfaces';
import { HubNames } from '../messages.interface';
import { validLegacyLinkOrigin } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { formulateAppMessageResult, onStatusError } from './messageHandlingUtils';
var LinkRouter = /** @class */ (function () {
    function LinkRouter(linkHandlers) {
        this.linkHandlers = linkHandlers;
    }
    LinkRouter.prototype.tryGetDataFromLink = function (url) {
        for (var _i = 0, _a = this.linkHandlers; _i < _a.length; _i++) {
            var handler = _a[_i];
            var data = handler.tryGetDataFromLink(url);
            if (data != null) {
                return [handler, data];
            }
        }
        return null;
    };
    LinkRouter.prototype.executeData = function (_a) {
        var handler = _a[0], data = _a[1];
        return handler.executeData(data);
    };
    return LinkRouter;
}());
export { LinkRouter };
/**
 * Responsible for handling deep link based calls like openLink.
 */
var LinkMessageHandler = /** @class */ (function (_super) {
    __extends(LinkMessageHandler, _super);
    function LinkMessageHandler(appSdkHost, linkService, linkHandler, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.linkService = linkService;
        _this.linkHandler = linkHandler;
        return _this;
    }
    LinkMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.links.openLink, function (_, url) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.executeLink(url)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, formulateAppMessageResult(true)];
                }
            });
        }); }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.links.openLink, error, scenario); },
        });
    };
    LinkMessageHandler.prototype.executeLink = function (url) {
        try {
            var parsedUrl = new URL(url);
            // Disable routing of deepLink URL for Teams Hub
            if (this.appSdkHost.getHubInfo().name !== HubNames.teams &&
                this.appSdkHost.getHubInfo().name !== HubNames.teamsModern &&
                this.linkHandler) {
                var data = this.linkHandler.tryGetDataFromLink(parsedUrl);
                if (data != null) {
                    return this.linkHandler.executeData(data);
                }
            }
        }
        catch (e) {
            // If there is an error parsing the URL, pass the url to openLink
            this.appSdkHost.getLogger().log(LogLevel.Error, 'LinkMessageHandler', 'There is an error parsing the URL', e);
        }
        return this.linkService.openLink(url);
    };
    LinkMessageHandler.prototype.validateDependencies = function () {
        if (!this.linkService) {
            throw 'No linkService provided';
        }
    };
    return LinkMessageHandler;
}(BaseMessageHandler));
export { LinkMessageHandler };
/**
 * Handler for App Links. The expected URL format is:
 * https://<any of appLinkDomains>/<appLinkRootPath>/<appId>/<pageId>?webUrl=<webUrl>&context=<context>
 * All query parameters are optional. The Context is a JSON object with optional fields for
 * subEntityId and channelId. The link may also contain a label, but this is for display purposes only
 * and is ignored for navigation.
 */
var AppLinkHandler = /** @class */ (function () {
    function AppLinkHandler(pageService) {
        this.pageService = pageService;
    }
    AppLinkHandler.prototype.tryGetDataFromLink = function (url) {
        if (!this.pageService) {
            return null;
        }
        if (url.protocol !== 'https:') {
            return null;
        }
        if (url.origin != validLegacyLinkOrigin) {
            return null;
        }
        var trimmedRootPath = '/l/entity/';
        if (!url.pathname.startsWith(trimmedRootPath)) {
            return null;
        }
        var pathParts = url.pathname.substring(trimmedRootPath.length).split('/');
        if (pathParts.length !== 2) {
            return null;
        }
        var appId = pathParts[0];
        var pageId = pathParts[1];
        var webUrl = url.searchParams.get('webUrl') || undefined;
        var contextString = url.searchParams.get('context');
        var subPageId;
        var channelId;
        var chatId;
        if (contextString) {
            try {
                var contextObject = JSON.parse(contextString);
                if (contextObject && typeof contextObject === 'object') {
                    subPageId = contextObject['subEntityId'];
                    channelId = contextObject['channelId'];
                    chatId = contextObject['chatId'];
                }
            }
            catch (_a) {
                // context was not valid JSON, ignore it
            }
        }
        return {
            appId: appId,
            pageId: pageId,
            webUrl: webUrl,
            subPageId: subPageId,
            channelId: channelId,
            chatId: chatId,
        };
    };
    AppLinkHandler.prototype.executeData = function (navigateToAppParams) {
        return this.pageService.navigateToApp(navigateToAppParams);
    };
    return AppLinkHandler;
}());
export { AppLinkHandler };
//# sourceMappingURL=link-message-handler.js.map